<template>
  <div class="phone-shell" :style="shellStyle">
    <div class="drag">
      <span class="iconfont icon-close" @click="unMount" :style="closeStyle"></span>
    </div>
    <div class="virtual-phone-layout" :style="layoutStyle">
      <nav-bar v-bind="currentRoute.navbar"></nav-bar>
      <div class="content">
        <component
          :is="currentRoute.name"
          ref="page"
          @hook:updated="cache"
          @hook:created="recovery"
        ></component>
      </div>
      <tab-bar :show="showTabbar" :active.sync="active" :list="tabbar" @switch="goto"></tab-bar>
    </div>
  </div>
</template>

<script>
import TabBar from './TabBar';
import NavBar from './NavBar';
import { enableDrag, makeCalculator } from '../utils';
import { tabbar } from '../router';
import Route from '../mixins/route';
import RootCache from '../mixins/rootCache';
// close
import { stopDetection } from '@/api/remoteControl';

let calc = null;

export default {
  components: {
    TabBar,
    NavBar
  },
  mixins: [Route, RootCache],
  provide() {
    calc = makeCalculator(this.width);
    return {
      calc,
      params: this.params
    };
  },
  props: {
    width: {
      type: [Number, String],
      default: 720
    },
    position: {
      type: Array,
      default: () => [400, 100]
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tabbar,
      events: null
    };
  },
  computed: {
    showTabbar() {
      const { currentRoute } = this;
      return this.tabbar.some(e => e.route === currentRoute.name);
    },
    shellStyle() {
      const { position } = this;
      return {
        left: `${position[0]}px`,
        top: `${position[1]}px`
      };
    },
    layoutStyle() {
      const { width } = this;
      return {
        width: `${width}px`,
        height: `${width * 1.7}px`
      };
    },
    closeStyle() {
      return {
        fontSize: calc(30)
      };
    }
  },
  methods: {
    costomMount() {
      const el = document.getElementsByClassName('phone-shell');
      // 只存在一个模拟设备
      if (el.length) el[0].remove();
      const body = /** @type {Element} */ this.$mount().$el;
      // 启用拖拽 .drag元素
      enableDrag(body, 'drag');
      document.body.append(body);
      this.events = event => {
        if (event.key === 'Escape') this.unMount();
      };
      window.addEventListener('keydown', this.events);
    },
    unMount() {
      // 手动销毁组件
      this.$destroy();
      // 移除监听事件
      window.removeEventListener('keydown', this.events);
      // 卸载节点
      this.$mount().$el.remove();
      // 清除模拟设备自定义缓存
      this.clear();
      // 关闭连接
      // close();
      const params = {
        sn: [this.params.sn]
      };
      stopDetection(params);
    }
  }
};
</script>

<style lang="scss">
.phone-shell {
  $phone-shell-primary: #01cab5;
  position: fixed;
  z-index: 9;
  padding: 1px;
  background-color: $phone-shell-primary;
  border-radius: 10px 10px 6px 6px;
  border: 0.5px solid $phone-shell-primary;
  overflow: hidden;
  .virtual-phone-layout {
    position: relative;
    background-color: #050505;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .content {
      flex: 1;
      overflow: hidden;
      user-select: none;
    }
  }

  .drag {
    background-color: $phone-shell-primary;
    height: 25px;
    cursor: grab;
    position: relative;
    &:active {
      cursor: grabbing;
    }
    .icon-close {
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      border-radius: 50%;
      padding: 3px;
      &:hover {
        background: #eee;
        color: #050505;
      }
    }
  }
}
</style>
